import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';

export class MapLibraryColmatchSelectionItem {
    mappedId: string;
    fieldsmatchedmsg: string;
    lastModified: string;
    color: string;
    mapType: string;

    constructor(mappedId: string, fieldsmatchedmsg: string, lastModified: string, color: string, mapType: string) {
      this.mappedId = mappedId;
      this.fieldsmatchedmsg = fieldsmatchedmsg;
      this.lastModified = lastModified;
      this.color = color;
      this.mapType = mapType;
    }
}

@Component({
  selector: 'app-maplibrary',
  templateUrl: './maplibrary.component.html',
  styleUrl: './maplibrary.component.css',
  standalone: false
})
export class MaplibraryComponent extends BaseComponent implements OnInit{
  title: string;
  currentNodefields: MapLibraryColmatchSelectionItem[]=[];
  allMapfields: MapLibraryColmatchSelectionItem[]=[];
  displayedColumns: string[] = ['Fields mapped', 'Last saved', 'action'];
  currentNodeMapdataSource: MatTableDataSource<any>;
  allMapdataSource: MatTableDataSource<any>;
  selectedMappingGUID: string = "";
  selectedMappingType: string = "";
  onClosed?: (eventname: string,selectedfield: string,selectedMapType: string ) => any;
  dragPosition = { x: 0, y: 0 };
  private initialMappedId: string | null = null;
  private initialMapType: string | null = null;

  constructor(private dialogRef: MatDialogRef<MaplibraryComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
    matDialog: MatDialog) {
    super(errorLogger, matDialog);
  }

  async ngOnInit(): Promise<void> {
    this.onClosed = this.dialogData?.onClosed;
    this.title = this.dialogData.title;
    this.currentNodefields = this.dialogData.currentNodefields;
    this.allMapfields = this.dialogData.allMapsfields;
    this.initialMappedId = this.dialogData?.initialMappedId ?? null;
    this.initialMapType = this.dialogData?.initialMapType ?? null;
    this.currentNodeMapdataSource=new MatTableDataSource(this.currentNodefields);
    this.allMapdataSource=new MatTableDataSource(this.allMapfields);

    const saved = localStorage.getItem('mapLibraryDialogPosition');
    if (saved) {
      this.dragPosition = JSON.parse(saved);
    }
  }

   async selectField(field: string): Promise<void> {
    let filteredItem = this.currentNodefields.filter(item => item.mappedId === field);
    var selectedMapType = "";
    this.selectedMappingGUID = field;
    if(filteredItem.length === 0){
      filteredItem = this.allMapfields.filter(item => item.mappedId === field);
      selectedMapType = filteredItem[0].mapType; 
    } else {
      selectedMapType = filteredItem[0].mapType;
    }
    this.selectedMappingType = selectedMapType;
    if (this.onClosed) {
      await this.onClosed('selectfield', field, selectedMapType);
    }
    //this.dialogRef.close({eventname:'selectfield', selectedfield: field, selectedMapType: selectedMapType});
   }
   
   //OK Button
   confirmMapping(): void {
    this.dialogRef.close({eventname:'confirmmapselection', selectedfield: this.selectedMappingGUID, selectedMapType: this.selectedMappingType});
   }

   //Cancel Button
   cancel(): void {
      this.dialogRef.close({eventname:'cancelmapselection', selectedfield: null, selectedMapType: "current_node"});
   }
  onDragEnd(event: CdkDragEnd) {
    const position = event.source.getFreeDragPosition();
    // Save in localStorage (or service)
    localStorage.setItem('mapLibraryDialogPosition', JSON.stringify(position));
  }
}
